import React from "react";
import { Link } from "react-router-dom";
import "../css/common.css";

/**
 * Page breadcrumb strip.
 *
 * Was a floating white Bootstrap `.breadcrumb` card (bg-light, rounded, its own
 * margins) sitting on a grey band — it read as a stray element rather than part
 * of the page. Now a slim, flush strip in the brand's warm neutrals, with the
 * current page as a non-link.
 *
 * It also carried a My Orders link, which duplicated the one in the account
 * menu (TopBar.js) — two routes to the same page, one of them in a breadcrumb,
 * where nobody looks for account actions. The account menu is the only one now.
 */
export default function Heading({ title, subtitle }) {
  return (
    <div className="nt-breadcrumb">
      <div className="nt-breadcrumb-inner">
        <nav className="nt-crumbs" aria-label="Breadcrumb">
          <Link to="/">{title}</Link>
          <i className="fas fa-chevron-right" aria-hidden="true"></i>
          <span aria-current="page">{subtitle}</span>
        </nav>
      </div>
    </div>
  );
}
